import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';

const API = 'https://api.hermespartnercapital.co';

function Dashboard() {
  const subdomain = (() => {
    const host = window.location.hostname;
    const parts = host.split('.');
    if (parts.length >= 3 && parts[0] !== 'www') return parts[0];
    return null;
  })();
  const isClientView = subdomain && subdomain !== 'app' && subdomain !== 'www';

  const [profile, setProfile] = useState(null);
  const [contacts, setContacts] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [calls, setCalls] = useState([]);
  const [vapiCalls, setVapiCalls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedCall, setSelectedCall] = useState(null);
  const [callModalTab, setCallModalTab] = useState('transcript');
  const [contactSearch, setContactSearch] = useState('');
  const [showCreateContact, setShowCreateContact] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);
 const [crmClients, setCrmClients] = useState([]);
const [showProvisionForm, setShowProvisionForm] = useState(false);
const [provisionForm, setProvisionForm] = useState({ business_name: '', subdomain: '', owner_name: '', owner_email: '', owner_phone: '', vapi_assistant_id: '', ghl_location_id: '', ghl_api_key: '' });
const [provisionStatus, setProvisionStatus] = useState('');
const [selectedClient, setSelectedClient] = useState(null);
const [showPluginManager, setShowPluginManager] = useState(false);
const [clientConfig, setClientConfig] = useState(null);
const [calendarView, setCalendarView] = useState('week');
const [calendarDate, setCalendarDate] = useState(new Date());
const [events, setEvents] = useState([]);
const [showEventForm, setShowEventForm] = useState(false);
const [eventForm, setEventForm] = useState({ title: '', date: '', time: '', duration: '60', type: 'appointment', notes: '', contact: '' });
const [eventStatus, setEventStatus] = useState('');
  const [notes, setNotes] = useState([]);
const [newNote, setNewNote] = useState('');
const [deleteConfirm, setDeleteConfirm] = useState(false);
const [editingContact, setEditingContact] = useState(false);
const [editForm, setEditForm] = useState({});
const [editStatus, setEditStatus] = useState('');
const [newContact, setNewContact] = useState({ firstName: '', lastName: '', phone: '', email: '', companyName: '' });
const [createStatus, setCreateStatus] = useState('');
  const [contactFilter, setContactFilter] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
    init();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) { navigate('/login'); return; }
    const { data: prof } = await supabase.from('profiles').select('*').eq('email', session.user.email).single();
    setProfile(prof);

    if (isClientView) {
      // Load client config from subdomain
      const res = await fetch(`${API}/api/crm-clients/subdomain/${subdomain}`);
      const data = await res.json();
      if (data.success) setClientConfig(data.client);
    }

    await fetchGHLData();
    if (!isClientView) await fetchCrmClients();
    await fetchEvents();
    setLoading(false);
  };

 const fetchGHLData = async () => {
    try {
     const clientId = isClientView && clientConfig ? `?subdomain=${subdomain}` : '';
      const [contactsRes, callsRes, vapiCallsRes] = await Promise.all([
        fetch(`${API}/api/ghl/contacts${clientId}`),
        fetch(`${API}/api/ghl/calls${clientId}`),
        fetch(`${API}/api/vapi/calls${clientId}`)
      ]);
      const contactsData = await contactsRes.json();
      const callsData = await callsRes.json();
      const vapiData = await vapiCallsRes.json();
      if (contactsData.success) setContacts(Array.isArray(contactsData.contacts) ? contactsData.contacts : []);
      if (callsData.success) setCalls(Array.isArray(callsData.conversations) ? callsData.conversations : []);
      if (vapiData.success) setVapiCalls(Array.isArray(vapiData.calls) ? vapiData.calls : []);
    } catch (err) {
      console.error('fetch error:', err);
    }
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

const fetchEvents = async () => {
    try {
      const sub = isClientView ? subdomain : 'hermes';
      const res = await fetch(`${API}/api/calendar/${sub}`);
      const data = await res.json();
      if (data.success) setEvents(data.events);
    } catch (err) {
      console.error(err);
    }
  };

const fetchCrmClients = async () => {
    try {
      const res = await fetch(`${API}/api/crm-clients`);
      const data = await res.json();
      if (data.success) setCrmClients(data.clients);
    } catch (err) {
      console.error(err);
    }
  };

const fetchNotes = async (contactId) => {
    try {
      const res = await fetch(`${API}/api/notes/${contactId}`);
      const data = await res.json();
      if (data.success) setNotes(data.notes);
    } catch (err) {
      console.error(err);
    }
  };

  const openCallModal = (call) => {
    setSelectedCall(call);
    setCallModalTab('transcript');
  };

  const getContactStatus = (c) => {
    if (c.type === 'customer') return 'customer';
    if (c.tags?.includes('Prospect') || c.tags?.includes('prospect')) return 'prospect';
    if (c.tags?.includes('Lost') || c.tags?.includes('lost')) return 'lost';
    return 'lead';
  };

  const statusColor = (type) => {
    const map = {
      lead: { bg: 'rgba(107,26,26,0.08)', color: '#6B1A1A' },
      customer: { bg: 'rgba(107,26,26,0.15)', color: '#4a1010' },
      prospect: { bg: 'rgba(201,168,130,0.15)', color: '#c9a882' },
      lost: { bg: 'rgba(100,100,100,0.1)', color: '#888' },
    };
    return map[type] || map.lead;
  };

  const getCallDuration = (c) => {
    if (c.duration) return c.duration;
    if (c.startedAt && c.endedAt) {
      return Math.round((new Date(c.endedAt) - new Date(c.startedAt)) / 1000);
    }
    return null;
  };

  const formatDuration = (seconds) => {
    if (!seconds) return '—';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  const isMissedCall = (c) => {
    const secs = getCallDuration(c);
    return secs !== null && secs < 30;
  };

useEffect(() => {
    if (selectedContact) {
      fetchNotes(selectedContact.id);
      setNotes([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContact?.id]);

  const filteredContacts = contacts.filter(c => {
    const matchesSearch = !contactSearch ||
      (c.contactName || '').toLowerCase().includes(contactSearch.toLowerCase()) ||
      (c.companyName || '').toLowerCase().includes(contactSearch.toLowerCase()) ||
      (c.phone || '').includes(contactSearch) ||
      (c.email || '').toLowerCase().includes(contactSearch.toLowerCase());
    const matchesFilter = contactFilter === 'all' || getContactStatus(c) === contactFilter;
    return matchesSearch && matchesFilter;
  });

  // Combined activity feed
  const activityItems = [
    ...contacts.map(c => ({
      type: 'contact',
      date: c.dateAdded ? new Date(c.dateAdded) : new Date(0),
      label: `New contact — `,
      name: c.contactName || c.companyName || 'Unknown',
      icon: '◉',
      color: '#c9a882',
      data: c,
    })),
    ...vapiCalls.map(c => ({
      type: 'call',
      date: c.startedAt ? new Date(c.startedAt) : new Date(0),
      label: isMissedCall(c) ? 'Missed call — ' : 'AI call handled — ',
      name: c.customer?.number || 'Unknown',
      icon: isMissedCall(c) ? '⚠' : '☎',
      color: isMissedCall(c) ? '#e07b39' : '#4DB87A',
      data: c,
    })),
  ].sort((a, b) => b.date - a.date).slice(0, 20);

  if (loading) return (
    <div style={{ backgroundColor: '#f0ebe3', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Cormorant Garamond, serif' }}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ color: '#6B1A1A', fontSize: '32px' }}>🦅</p>
        <p style={{ color: '#888', fontSize: '14px', marginTop: '16px', letterSpacing: '2px' }}>LOADING...</p>
      </div>
    </div>
  );

  const activeContacts = contacts.filter(c => c.type !== 'lost');
  const newLeads = contacts.filter(c => c.type === 'lead').length;
  const missedCalls = vapiCalls.filter(isMissedCall).length;

  const modalTabStyle = (key) => ({
    padding: '10px 20px',
    fontSize: '11px',
    letterSpacing: '2px',
    fontFamily: 'Cormorant Garamond, serif',
    cursor: 'pointer',
    border: 'none',
    borderBottom: callModalTab === key ? '2px solid #c9a882' : '2px solid transparent',
    backgroundColor: 'transparent',
    color: callModalTab === key ? '#c9a882' : 'rgba(201,168,130,0.4)',
    fontWeight: callModalTab === key ? '700' : '400',
  });

  return (
    <div style={{ backgroundColor: '#f0ebe3', minHeight: '100vh', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', display: 'flex' }}>

      {/* SIDEBAR */}
      <div style={{ width: '220px', minHeight: '100vh', backgroundColor: '#4a1010', borderRight: '1px solid #6B1A1A', display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0 }}>
        <div style={{ padding: '24px 20px', borderBottom: '1px solid rgba(201,168,130,0.2)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '32px', height: '32px', background: 'linear-gradient(135deg, #6B1A1A, #4a1010)', border: '1px solid #c9a882', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>🦅</div>
            <div>
              <p style={{ color: '#c9a882', fontSize: '12px', fontWeight: '700', margin: 0, letterSpacing: '2px' }}>{isClientView && clientConfig ? clientConfig.business_name.toUpperCase() : 'HERMES'}</p>
              <p style={{ color: 'rgba(201,168,130,0.5)', fontSize: '9px', letterSpacing: '1px', margin: 0 }}>{isClientView ? 'CLIENT PORTAL' : 'PARTNER CAPITAL'}</p>
            </div>
          </div>
          <p style={{ color: 'rgba(201,168,130,0.7)', fontSize: '11px', margin: '12px 0 0', lineHeight: '1.4' }}>{profile?.full_name}</p>
        </div>
        <nav style={{ padding: '12px 10px', flex: 1 }}>
          {[
            { key: 'overview', label: 'Overview', icon: '◈' },
            ...((!isClientView || clientConfig?.plugins?.contacts) ? [{ key: 'contacts', label: 'Contacts', icon: '◉' }] : []),
            ...((!isClientView || clientConfig?.plugins?.ai_call_log) ? [{ key: 'calls', label: 'AI Call Log', icon: '☎' }] : []),
            ...((!isClientView || clientConfig?.plugins?.activity) ? [{ key: 'activity', label: 'Activity', icon: '◷' }] : []),
            ...((!isClientView || clientConfig?.plugins?.contacts) ? [{ key: 'pipeline', label: 'Pipeline', icon: '◫' }] : []),
            ...(!isClientView ? [{ key: 'clients', label: 'Clients', icon: '◻' }] : []),
            ...((!isClientView || clientConfig?.plugins?.calendar) ? [{ key: 'calendar', label: 'Calendar', icon: '◳' }] : []),
          ].map(item => (
            <div key={item.key} onClick={() => setActiveTab(item.key)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 10px', borderRadius: '8px', cursor: 'pointer', marginBottom: '2px', backgroundColor: activeTab === item.key ? 'rgba(201,168,130,0.15)' : 'transparent', color: activeTab === item.key ? '#c9a882' : 'rgba(201,168,130,0.5)', fontSize: '13px', fontWeight: '500', borderLeft: activeTab === item.key ? '3px solid #c9a882' : '3px solid transparent' }}>
              <span style={{ fontSize: '14px' }}>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </nav>
        <div style={{ padding: '14px', borderTop: '1px solid rgba(201,168,130,0.2)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: 'rgba(77,184,122,0.1)', border: '1px solid rgba(77,184,122,0.2)', borderRadius: '8px', padding: '10px 12px', marginBottom: '8px' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#4DB87A' }} />
            <div>
              <p style={{ color: '#4DB87A', fontSize: '11px', fontWeight: '600', margin: 0 }}>AI Live</p>
              <p style={{ color: 'rgba(77,184,122,0.55)', fontSize: '9px', margin: 0 }}>System active</p>
            </div>
          </div>
          <button onClick={handleSignOut} style={{ width: '100%', backgroundColor: 'transparent', border: '1px solid rgba(201,168,130,0.2)', color: 'rgba(201,168,130,0.5)', fontSize: '11px', padding: '8px', borderRadius: '8px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '1px' }}>
            SIGN OUT
          </button>
        </div>
      </div>

      {/* MAIN */}
      <div style={{ marginLeft: '220px', flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px 28px', borderBottom: '1px solid #d4c9bc', backgroundColor: '#f0ebe3', position: 'sticky', top: 0, zIndex: 50 }}>
          <div>
            <p style={{ fontSize: '17px', fontWeight: '700', color: '#2a1a1a', margin: 0, fontFamily: 'Playfair Display, serif' }}>{activeTab === 'calls' ? 'AI Call Log' : activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</p>
            <p style={{ fontSize: '11px', color: '#888', margin: '2px 0 0', fontFamily: 'monospace' }}>{new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}</p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {!isClientView && (
              <button onClick={() => navigate('/admin')} style={{ backgroundColor: 'transparent', border: '0.5px solid #d4c9bc', color: '#555', fontSize: '11px', padding: '7px 14px', borderRadius: '8px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '1px' }}>
                ← ADMIN
              </button>
            )}
            <button onClick={fetchGHLData} style={{ backgroundColor: 'transparent', border: '0.5px solid #d4c9bc', color: '#555', fontSize: '11px', padding: '7px 14px', borderRadius: '8px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '1px' }}>
              ↻ REFRESH
            </button>
          </div>
        </div>

        <div style={{ padding: '24px 28px' }}>

          {/* OVERVIEW */}
          {activeTab === 'overview' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1px', backgroundColor: '#d4c9bc', border: '1px solid #d4c9bc', marginBottom: '24px' }}>
                {[
                  { label: 'TOTAL CONTACTS', value: contacts.length, sub: `${newLeads} new leads` },
                  { label: 'ACTIVE LEADS', value: activeContacts.length, sub: 'in pipeline' },
                  { label: 'AI CALLS', value: vapiCalls.length, sub: 'total calls logged' },
                  { label: 'MISSED CALLS', value: missedCalls, sub: 'under 30 seconds', alert: missedCalls > 0 },
                ].map((kpi, i) => (
                  <div key={i} style={{ backgroundColor: '#f0ebe3', padding: '24px', borderLeft: kpi.alert ? '3px solid #e07b39' : 'none' }}>
                    <p style={{ color: kpi.alert ? '#e07b39' : '#6B1A1A', fontSize: '10px', letterSpacing: '3px', margin: '0 0 8px' }}>{kpi.label}</p>
                    <p style={{ fontSize: '28px', fontWeight: '700', color: kpi.alert ? '#e07b39' : '#2a1a1a', fontFamily: 'Playfair Display, serif', margin: '0 0 4px' }}>{kpi.value}</p>
                    <p style={{ fontSize: '11px', color: '#c9a882', margin: 0 }}>{kpi.sub}</p>
                  </div>
                ))}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '14px' }}>
                <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '13px 18px', borderBottom: '1px solid #d4c9bc', backgroundColor: '#4a1010' }}>
                    <p style={{ fontSize: '11px', fontWeight: '600', color: '#c9a882', margin: 0, letterSpacing: '2px' }}>RECENT CONTACTS</p>
                    <button onClick={() => setActiveTab('contacts')} style={{ fontSize: '11px', color: '#c9a882', background: 'none', border: 'none', cursor: 'pointer', letterSpacing: '1px' }}>View all →</button>
                  </div>
                  {contacts.length === 0 ? (
                    <div style={{ padding: '36px 20px', textAlign: 'center' }}>
                      <p style={{ color: '#888', fontSize: '13px', fontStyle: 'italic', margin: '0 0 8px' }}>No contacts yet</p>
                      <p style={{ color: '#bbb', fontSize: '11px', margin: 0, lineHeight: '1.6' }}>Contacts will appear here automatically when leads come in through your AI receptionist or are added to your CRM.</p>
                    </div>
                  ) : contacts.slice(0, 6).map((c, i) => (
                    <div key={i} onClick={() => setSelectedContact(c)} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 18px', borderBottom: '1px solid #d4c9bc', cursor: 'pointer', backgroundColor: 'white' }}>
                      <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'rgba(107,26,26,0.08)', color: '#6B1A1A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>
                        {(c.contactName || c.companyName || '?')[0].toUpperCase()}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#2a1a1a', margin: 0 }}>{c.contactName || c.companyName || 'Unknown'}</p>
                        <p style={{ fontSize: '11px', color: '#888', margin: '2px 0 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.phone || c.email || 'No contact info'}</p>
                      </div>
                      <span style={{ ...statusColor(getContactStatus(c)), padding: '2px 8px', borderRadius: '20px', fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>{getContactStatus(c)}</span>
                    </div>
                  ))}
                </div>

                <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
                  <div style={{ padding: '13px 18px', borderBottom: '1px solid #d4c9bc', backgroundColor: '#4a1010' }}>
                    <p style={{ fontSize: '11px', fontWeight: '600', color: '#c9a882', margin: 0, letterSpacing: '2px' }}>RECENT AI CALLS</p>
                  </div>
                  {vapiCalls.length === 0 ? (
                    <div style={{ padding: '36px 20px', textAlign: 'center', color: '#888', fontSize: '13px', fontStyle: 'italic' }}>No calls yet</div>
                  ) : vapiCalls.slice(0, 6).map((c, i) => {
                    const missed = isMissedCall(c);
                    return (
                      <div key={i} onClick={() => openCallModal(c)} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 18px', borderBottom: '1px solid #d4c9bc', cursor: 'pointer', borderLeft: missed ? '3px solid #e07b39' : '3px solid transparent' }}>
                        <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: missed ? 'rgba(224,123,57,0.1)' : 'rgba(107,26,26,0.08)', color: missed ? '#e07b39' : '#6B1A1A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', flexShrink: 0 }}>
                          {missed ? '⚠' : '☎'}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p style={{ fontSize: '13px', fontWeight: '600', color: '#2a1a1a', margin: 0 }}>{c.customer?.number || 'Unknown'}</p>
                          <p style={{ fontSize: '11px', color: missed ? '#e07b39' : '#888', margin: '2px 0 0' }}>
                            {formatDuration(getCallDuration(c))} · {missed ? 'missed' : c.status}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          {/* CONTACTS */}
          {activeTab === 'contacts' && (
            <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
              <div style={{ padding: '13px 18px', borderBottom: '1px solid #d4c9bc', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#4a1010' }}>
                <p style={{ fontSize: '11px', fontWeight: '600', color: '#c9a882', margin: 0, letterSpacing: '2px' }}>ALL CONTACTS</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
  <p style={{ fontSize: '11px', color: 'rgba(201,168,130,0.5)', margin: 0, fontFamily: 'monospace' }}>{filteredContacts.length} of {contacts.length}</p>
  <button onClick={() => setShowCreateContact(true)} style={{ backgroundColor: '#c9a882', color: '#4a1010', fontSize: '10px', letterSpacing: '2px', padding: '6px 14px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', fontWeight: '700' }}>+ NEW</button>
</div>
              </div>

              {/* Search + Filter bar */}
              <div style={{ display: 'flex', gap: '10px', padding: '12px 18px', borderBottom: '1px solid #d4c9bc', backgroundColor: '#f9f7f4' }}>
                <input
                  placeholder="Search by name, phone, email..."
                  value={contactSearch}
                  onChange={e => setContactSearch(e.target.value)}
                  style={{ flex: 1, padding: '8px 12px', fontSize: '12px', border: '1px solid #d4c9bc', backgroundColor: 'white', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none' }}
                />
                <select
                  value={contactFilter}
                  onChange={e => setContactFilter(e.target.value)}
                  style={{ padding: '8px 12px', fontSize: '11px', border: '1px solid #d4c9bc', backgroundColor: 'white', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', letterSpacing: '1px', cursor: 'pointer' }}
                >
                  <option value="all">All Types</option>
                  <option value="lead">Leads</option>
                  <option value="prospect">Prospects</option>
                  <option value="customer">Customers</option>
                </select>
              </div>

              {filteredContacts.length === 0 ? (
                <div style={{ padding: '60px 20px', textAlign: 'center' }}>
                  <p style={{ color: '#888', fontSize: '14px', fontStyle: 'italic', margin: '0 0 10px' }}>{contacts.length === 0 ? 'No contacts yet' : 'No results found'}</p>
                  <p style={{ color: '#bbb', fontSize: '12px', margin: 0, lineHeight: '1.8', maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
                    {contacts.length === 0 ? 'Contacts are automatically created when your AI receptionist handles a call or when leads are added to your CRM pipeline.' : 'Try adjusting your search or filter.'}
                  </p>
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f0ebe3' }}>
                        {['Name', 'Company', 'Phone', 'Email', 'Type', 'Added'].map(h => (
                          <th key={h} style={{ fontSize: '9px', letterSpacing: '2px', textTransform: 'uppercase', color: '#888', padding: '10px 18px', textAlign: 'left', borderBottom: '1px solid #d4c9bc', fontWeight: '500' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredContacts.map((c, i) => (
                        <tr key={i} onClick={() => setSelectedContact(c)} style={{ cursor: 'pointer', backgroundColor: 'white' }}>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '13px', fontWeight: '600', color: '#2a1a1a' }}>{c.contactName || '—'}</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '12px', color: '#555' }}>{c.companyName || '—'}</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '11px', color: '#555', fontFamily: 'monospace' }}>{c.phone || '—'}</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '10px', color: '#555', fontFamily: 'monospace' }}>{c.email || '—'}</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc' }}>
                            <span style={{ ...statusColor(getContactStatus(c)), padding: '2px 8px', borderRadius: '20px', fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>{getContactStatus(c)}</span>
                          </td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '10px', color: '#888', fontFamily: 'monospace' }}>{c.dateAdded ? new Date(c.dateAdded).toLocaleDateString() : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* AI CALL LOG */}
          {activeTab === 'calls' && (
            <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
              <div style={{ padding: '13px 18px', borderBottom: '1px solid #d4c9bc', display: 'flex', justifyContent: 'space-between', backgroundColor: '#4a1010' }}>
                <p style={{ fontSize: '11px', fontWeight: '600', color: '#c9a882', margin: 0, letterSpacing: '2px' }}>AI CALL LOG</p>
                <p style={{ fontSize: '11px', color: 'rgba(201,168,130,0.5)', margin: 0, fontFamily: 'monospace' }}>{vapiCalls.length} calls · {missedCalls} missed</p>
              </div>
              {vapiCalls.length === 0 ? (
                <div style={{ padding: '60px 20px', textAlign: 'center', color: '#888', fontSize: '13px', fontStyle: 'italic' }}>No calls yet. Your AI receptionist will log calls here automatically.</div>
              ) : vapiCalls.map((c, i) => {
                const missed = isMissedCall(c);
                return (
                  <div key={i} onClick={() => openCallModal(c)} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 18px', borderBottom: '1px solid #d4c9bc', cursor: 'pointer', borderLeft: missed ? '3px solid #e07b39' : '3px solid transparent' }}>
                    <div style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: missed ? 'rgba(224,123,57,0.1)' : 'rgba(107,26,26,0.08)', color: missed ? '#e07b39' : '#6B1A1A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0 }}>
                      {missed ? '⚠' : '☎'}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <p style={{ fontSize: '14px', fontWeight: '600', color: '#2a1a1a', margin: '0 0 2px' }}>{c.customer?.number || 'Unknown Caller'}</p>
                        {missed && <span style={{ fontSize: '9px', padding: '2px 8px', borderRadius: '20px', backgroundColor: 'rgba(224,123,57,0.1)', color: '#e07b39', fontWeight: '700', letterSpacing: '1px' }}>MISSED</span>}
                      </div>
                      <p style={{ fontSize: '11px', color: '#888', margin: 0 }}>{c.summary || 'AI receptionist call'}</p>
                    </div>
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <p style={{ fontSize: '11px', color: '#555', margin: '0 0 4px', fontFamily: 'monospace' }}>{formatDuration(getCallDuration(c))}</p>
                      <p style={{ fontSize: '10px', color: '#888', margin: '0 0 4px', fontFamily: 'monospace' }}>{c.startedAt ? new Date(c.startedAt).toLocaleDateString() : '—'}</p>
                      <span style={{ fontSize: '9px', padding: '2px 8px', borderRadius: '20px', backgroundColor: missed ? 'rgba(224,123,57,0.1)' : c.status === 'ended' ? 'rgba(107,26,26,0.08)' : 'rgba(201,168,130,0.1)', color: missed ? '#e07b39' : c.status === 'ended' ? '#6B1A1A' : '#c9a882', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>{missed ? 'missed' : c.status || 'completed'}</span>
                    </div>
                    <div style={{ color: '#c9a882', fontSize: '12px', marginLeft: '8px' }}>→</div>
                  </div>
                );
              })}
            </div>
          )}

{/* PIPELINE */}
          {activeTab === 'pipeline' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '14px' }}>
                {['lead', 'prospect', 'customer', 'lost'].map(stage => {
                  const stageContacts = contacts.filter(c => getContactStatus(c) === stage);
                  const stageLabels = { lead: 'LEADS', prospect: 'PROSPECTS', customer: 'CUSTOMERS', lost: 'LOST' };
                  const stageColors = { lead: '#c9a882', prospect: '#c9a882', customer: '#4DB87A', lost: '#aaa' };
                  return (
                    <div key={stage}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', backgroundColor: '#4a1010', marginBottom: '1px' }}>
                        <p style={{ fontSize: '10px', letterSpacing: '3px', color: stageColors[stage], margin: 0, fontWeight: '700' }}>{stageLabels[stage]}</p>
                        <span style={{ fontSize: '11px', color: 'rgba(201,168,130,0.5)', fontFamily: 'monospace' }}>{stageContacts.length}</span>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', minHeight: '200px' }}>
                        {stageContacts.length === 0 ? (
                          <div style={{ padding: '20px', backgroundColor: 'white', border: '1px solid #d4c9bc', textAlign: 'center' }}>
                            <p style={{ fontSize: '12px', color: '#bbb', fontStyle: 'italic', margin: 0 }}>None</p>
                          </div>
                        ) : stageContacts.map((c, i) => (
                          <div key={i} onClick={() => setSelectedContact(c)} style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', padding: '12px 14px', cursor: 'pointer', borderLeft: `3px solid ${stageColors[stage]}` }}>
                            <p style={{ fontSize: '13px', fontWeight: '600', color: '#2a1a1a', margin: '0 0 4px' }}>{c.contactName || c.companyName || 'Unknown'}</p>
                            <p style={{ fontSize: '11px', color: '#888', margin: '0 0 4px', fontFamily: 'monospace' }}>{c.phone || c.email || '—'}</p>
                            {c.dateAdded && <p style={{ fontSize: '10px', color: '#bbb', margin: 0, fontFamily: 'monospace' }}>{new Date(c.dateAdded).toLocaleDateString()}</p>}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

{/* CLIENTS */}
          {activeTab === 'clients' && (
            <div>
              <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
                <div style={{ padding: '13px 18px', borderBottom: '1px solid #d4c9bc', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#4a1010' }}>
                  <p style={{ fontSize: '11px', fontWeight: '600', color: '#c9a882', margin: 0, letterSpacing: '2px' }}>CRM CLIENTS</p>
                </div>
                {crmClients.length === 0 ? (
                  <div style={{ padding: '60px 20px', textAlign: 'center' }}>
                    <p style={{ color: '#888', fontSize: '14px', fontStyle: 'italic', margin: '0 0 10px' }}>No clients yet</p>
                    <p style={{ color: '#bbb', fontSize: '12px', margin: 0 }}>Clients are provisioned through the onboarding panel in the Admin dashboard.</p>
                  </div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f0ebe3' }}>
                        {['Business', 'Owner', 'Subdomain', 'Status', 'Created'].map(h => (
                          <th key={h} style={{ fontSize: '9px', letterSpacing: '2px', textTransform: 'uppercase', color: '#888', padding: '10px 18px', textAlign: 'left', borderBottom: '1px solid #d4c9bc', fontWeight: '500' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {crmClients.map((c, i) => (
                        <tr key={i} onClick={() => { setSelectedClient(c); setShowPluginManager(true); }} style={{ backgroundColor: 'white', cursor: 'pointer' }}>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '13px', fontWeight: '600', color: '#2a1a1a' }}>{c.business_name}</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '12px', color: '#555' }}>{c.owner_name}</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '11px', color: '#6B1A1A', fontFamily: 'monospace' }}>{c.subdomain}.hermespartnercapital.com</td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc' }}>
                            <span style={{ backgroundColor: c.status === 'active' ? 'rgba(77,184,122,0.1)' : 'rgba(107,26,26,0.08)', color: c.status === 'active' ? '#4DB87A' : '#6B1A1A', padding: '2px 8px', borderRadius: '20px', fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>{c.status}</span>
                          </td>
                          <td style={{ padding: '11px 18px', borderBottom: '1px solid #d4c9bc', fontSize: '10px', color: '#888', fontFamily: 'monospace' }}>{new Date(c.created_at).toLocaleDateString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

{/* CALENDAR */}
          {activeTab === 'calendar' && (
            <div>
              {/* Calendar Header */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <button onClick={() => {
                    const d = new Date(calendarDate);
                    calendarView === 'week' ? d.setDate(d.getDate() - 7) : d.setMonth(d.getMonth() - 1);
                    setCalendarDate(d);
                  }} style={{ background: 'none', border: '1px solid #d4c9bc', padding: '6px 12px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', fontSize: '16px' }}>‹</button>
                  <p style={{ fontFamily: 'Playfair Display, serif', fontSize: '18px', fontWeight: '700', color: '#2a1a1a', margin: 0 }}>
                    {calendarView === 'week'
                      ? `${new Date(calendarDate.getFullYear(), calendarDate.getMonth(), calendarDate.getDate() - calendarDate.getDay()).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })} – ${new Date(calendarDate.getFullYear(), calendarDate.getMonth(), calendarDate.getDate() - calendarDate.getDay() + 6).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`
                      : calendarDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                    }
                  </p>
                  <button onClick={() => {
                    const d = new Date(calendarDate);
                    calendarView === 'week' ? d.setDate(d.getDate() + 7) : d.setMonth(d.getMonth() + 1);
                    setCalendarDate(d);
                  }} style={{ background: 'none', border: '1px solid #d4c9bc', padding: '6px 12px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', fontSize: '16px' }}>›</button>
                  <button onClick={() => setCalendarDate(new Date())} style={{ background: 'none', border: '1px solid #d4c9bc', padding: '6px 14px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', fontSize: '11px', letterSpacing: '1px', color: '#555' }}>TODAY</button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ display: 'flex', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
                    {['week', 'month'].map(v => (
                      <button key={v} onClick={() => setCalendarView(v)} style={{ padding: '6px 16px', fontSize: '11px', letterSpacing: '1px', fontFamily: 'Cormorant Garamond, serif', border: 'none', cursor: 'pointer', backgroundColor: calendarView === v ? '#4a1010' : 'white', color: calendarView === v ? '#c9a882' : '#555' }}>
                        {v.toUpperCase()}
                      </button>
                    ))}
                  </div>
                  <button onClick={() => setShowEventForm(true)} style={{ backgroundColor: '#6B1A1A', color: '#f0ebe3', padding: '7px 18px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif' }}>+ EVENT</button>
                </div>
              </div>

              {/* WEEK VIEW */}
              {calendarView === 'week' && (() => {
                const startOfWeek = new Date(calendarDate);
                startOfWeek.setDate(calendarDate.getDate() - calendarDate.getDay());
                const days = Array.from({ length: 7 }, (_, i) => {
                  const d = new Date(startOfWeek);
                  d.setDate(startOfWeek.getDate() + i);
                  return d;
                });
                const today = new Date();
                return (
                  <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
                    {/* Day headers */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: '1px solid #d4c9bc' }}>
                      {days.map((day, i) => {
                        const isToday = day.toDateString() === today.toDateString();
                        return (
                          <div key={i} style={{ padding: '12px 8px', textAlign: 'center', borderRight: i < 6 ? '1px solid #d4c9bc' : 'none', backgroundColor: isToday ? '#4a1010' : '#f0ebe3' }}>
                            <p style={{ fontSize: '10px', letterSpacing: '2px', color: isToday ? '#c9a882' : '#888', margin: '0 0 4px' }}>{day.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase()}</p>
                            <p style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', fontWeight: '700', color: isToday ? '#f0ebe3' : '#2a1a1a', margin: 0 }}>{day.getDate()}</p>
                          </div>
                        );
                      })}
                    </div>
                    {/* Events per day */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', minHeight: '400px' }}>
                      {days.map((day, i) => {
                        const dayEvents = events.filter(e => new Date(e.date + 'T12:00:00').toDateString() === day.toDateString());
                        const isToday = day.toDateString() === today.toDateString();
                        return (
                          <div key={i} style={{ borderRight: i < 6 ? '1px solid #d4c9bc' : 'none', padding: '8px', minHeight: '400px', backgroundColor: isToday ? 'rgba(74,16,16,0.02)' : 'white' }}>
                            {dayEvents.map((ev, j) => (
                              <div key={j} style={{ backgroundColor: ev.type === 'appointment' ? 'rgba(107,26,26,0.08)' : ev.type === 'follow-up' ? 'rgba(201,168,130,0.15)' : 'rgba(77,184,122,0.1)', border: `1px solid ${ev.type === 'appointment' ? 'rgba(107,26,26,0.2)' : ev.type === 'follow-up' ? 'rgba(201,168,130,0.3)' : 'rgba(77,184,122,0.3)'}`, borderRadius: '4px', padding: '6px 8px', marginBottom: '4px', cursor: 'pointer' }}>
                                <p style={{ fontSize: '11px', fontWeight: '700', color: '#2a1a1a', margin: '0 0 2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ev.title}</p>
                                {ev.time && <p style={{ fontSize: '10px', color: '#888', margin: 0, fontFamily: 'monospace' }}>{ev.time.slice(0, 5)}</p>}
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })()}

              {/* MONTH VIEW */}
              {calendarView === 'month' && (() => {
                const year = calendarDate.getFullYear();
                const month = calendarDate.getMonth();
                const firstDay = new Date(year, month, 1).getDay();
                const daysInMonth = new Date(year, month + 1, 0).getDate();
                const today = new Date();
                const cells = Array.from({ length: firstDay + daysInMonth }, (_, i) => i < firstDay ? null : i - firstDay + 1);
                while (cells.length % 7 !== 0) cells.push(null);
                const weeks = [];
                for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
                return (
                  <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: '1px solid #d4c9bc' }}>
                      {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map(d => (
                        <div key={d} style={{ padding: '10px', textAlign: 'center', backgroundColor: '#f0ebe3' }}>
                          <p style={{ fontSize: '10px', letterSpacing: '2px', color: '#888', margin: 0 }}>{d}</p>
                        </div>
                      ))}
                    </div>
                    {weeks.map((week, wi) => (
                      <div key={wi} style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: wi < weeks.length - 1 ? '1px solid #d4c9bc' : 'none' }}>
                        {week.map((day, di) => {
                          if (!day) return <div key={di} style={{ minHeight: '100px', borderRight: di < 6 ? '1px solid #d4c9bc' : 'none', backgroundColor: '#f9f7f4' }} />;
                          const date = new Date(year, month, day);
                          const isToday = date.toDateString() === today.toDateString();
                          const dayEvents = events.filter(e => new Date(e.date + 'T12:00:00').toDateString() === date.toDateString());
                          return (
                            <div key={di} style={{ minHeight: '100px', borderRight: di < 6 ? '1px solid #d4c9bc' : 'none', padding: '6px', backgroundColor: isToday ? 'rgba(74,16,16,0.03)' : 'white' }}>
                              <p style={{ fontSize: '13px', fontWeight: isToday ? '700' : '400', color: isToday ? '#6B1A1A' : '#2a1a1a', margin: '0 0 4px', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: isToday ? 'rgba(107,26,26,0.1)' : 'transparent', borderRadius: '50%' }}>{day}</p>
                              {dayEvents.slice(0, 3).map((ev, j) => (
                                <div key={j} style={{ backgroundColor: ev.type === 'appointment' ? 'rgba(107,26,26,0.08)' : ev.type === 'follow-up' ? 'rgba(201,168,130,0.15)' : 'rgba(77,184,122,0.1)', borderRadius: '3px', padding: '2px 6px', marginBottom: '2px' }}>
                                  <p style={{ fontSize: '10px', color: '#2a1a1a', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ev.title}</p>
                                </div>
                              ))}
                              {dayEvents.length > 3 && <p style={{ fontSize: '10px', color: '#888', margin: '2px 0 0' }}>+{dayEvents.length - 3} more</p>}
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          )}

          {/* ACTIVITY */}
          {activeTab === 'activity' && (
            <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', overflow: 'hidden' }}>
              <div style={{ padding: '13px 18px', borderBottom: '1px solid #d4c9bc', backgroundColor: '#4a1010' }}>
                <p style={{ fontSize: '11px', fontWeight: '600', color: '#c9a882', margin: 0, letterSpacing: '2px' }}>RECENT ACTIVITY</p>
              </div>
              {activityItems.length === 0 ? (
                <div style={{ padding: '60px 20px', textAlign: 'center', color: '#888', fontSize: '13px', fontStyle: 'italic' }}>No activity yet.</div>
              ) : activityItems.map((item, i) => (
                <div key={i} onClick={() => item.type === 'call' ? openCallModal(item.data) : setSelectedContact(item.data)} style={{ display: 'flex', gap: '12px', padding: '12px 18px', borderBottom: '1px solid #d4c9bc', cursor: 'pointer', alignItems: 'flex-start' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: item.type === 'call' && isMissedCall(item.data) ? 'rgba(224,123,57,0.1)' : 'rgba(201,168,130,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', flexShrink: 0, color: item.color }}>
                    {item.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontSize: '13px', color: '#2a1a1a', margin: '0 0 2px' }}>
                      {item.label}<strong>{item.name}</strong>
                      {item.type === 'call' && (
                        <span style={{ fontSize: '11px', color: '#888', fontWeight: '400' }}> · {formatDuration(getCallDuration(item.data))}</span>
                      )}
                    </p>
                    <p style={{ fontSize: '10px', color: '#888', margin: 0, fontFamily: 'monospace' }}>{item.date && item.date.getTime() > 0 ? item.date.toLocaleString() : '—'}</p>
                  </div>
                  {item.type === 'call' && isMissedCall(item.data) && (
                    <span style={{ fontSize: '9px', padding: '2px 8px', borderRadius: '20px', backgroundColor: 'rgba(224,123,57,0.1)', color: '#e07b39', fontWeight: '700', letterSpacing: '1px', flexShrink: 0 }}>MISSED</span>
                  )}
                </div>
              ))}
            </div>
          )}

        </div>
      </div>

      {/* CONTACT MODAL */}
      {selectedContact && (
        <div onClick={() => setSelectedContact(null)} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', width: '480px', maxHeight: '80vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #d4c9bc', position: 'sticky', top: 0, backgroundColor: '#4a1010' }}>
              <div>
                <p style={{ fontSize: '14px', fontWeight: '700', color: '#c9a882', margin: 0, fontFamily: 'Playfair Display, serif' }}>{selectedContact.contactName || selectedContact.companyName || 'Contact'}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
  <select
    value={getContactStatus(selectedContact)}
    onChange={async (e) => {
      const newType = e.target.value;
      setUpdatingStatus(true);
      try {
      const updatedTags = (selectedContact.tags || []).filter(t => 
  t.toLowerCase() !== 'prospect' && t.toLowerCase() !== 'lost'
);
const newTags = newType === 'prospect' ? [...updatedTags, 'prospect'] 
  : newType === 'lost' ? [...updatedTags, 'lost'] 
  : updatedTags;

setSelectedContact({ ...selectedContact, type: newType === 'customer' ? 'customer' : 'lead', tags: newTags });
setContacts(prev => prev.map(c => c.id === selectedContact.id ? { ...c, type: newType === 'customer' ? 'customer' : 'lead', tags: newTags } : c));
fetch(`${API}/api/ghl/contacts/${selectedContact.id}`, {
  method: 'PUT',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ type: newType })
});
      } catch (err) {
        console.error(err);
      }
      setUpdatingStatus(false);
    }}
    style={{ backgroundColor: 'transparent', border: '1px solid rgba(201,168,130,0.3)', color: '#c9a882', fontSize: '10px', letterSpacing: '2px', padding: '3px 8px', fontFamily: 'Cormorant Garamond, serif', cursor: 'pointer', outline: 'none' }}
  >
    <option value="lead">LEAD</option>
    <option value="prospect">PROSPECT</option>
    <option value="customer">CUSTOMER</option>
    <option value="lost">LOST</option>
  </select>
  {updatingStatus && <span style={{ fontSize: '10px', color: '#c9a882' }}>saving...</span>}
</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  {deleteConfirm ? (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ fontSize: '11px', color: '#e07b39' }}>Delete?</span>
      <button onClick={async () => {
        try {
          await fetch(`${API}/api/ghl/contacts/${selectedContact.id}`, { method: 'DELETE' });
          setSelectedContact(null);
          setDeleteConfirm(false);
          await fetchGHLData();
        } catch (err) { console.error(err); }
      }} style={{ background: 'none', border: '1px solid #e07b39', color: '#e07b39', fontSize: '10px', padding: '3px 8px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '1px' }}>YES</button>
      <button onClick={() => setDeleteConfirm(false)} style={{ background: 'none', border: '1px solid rgba(201,168,130,0.3)', color: '#c9a882', fontSize: '10px', padding: '3px 8px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', letterSpacing: '1px' }}>NO</button>
    </div>
  ) : (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <button onClick={() => { setEditingContact(true); setEditForm({ firstName: selectedContact.contactName?.split(' ')[0] || '', lastName: selectedContact.contactName?.split(' ').slice(1).join(' ') || '', phone: selectedContact.phone || '', email: selectedContact.email || '', companyName: selectedContact.companyName || '' }); }} style={{ background: 'none', border: 'none', color: 'rgba(201,168,130,0.5)', fontSize: '13px', cursor: 'pointer' }}>✎</button>
      <button onClick={() => setDeleteConfirm(true)} style={{ background: 'none', border: 'none', color: 'rgba(201,168,130,0.3)', fontSize: '13px', cursor: 'pointer' }}>🗑</button>
    </div>
  )}
  <button onClick={() => { setSelectedContact(null); setDeleteConfirm(false); }} style={{ background: 'none', border: 'none', color: '#c9a882', fontSize: '17px', cursor: 'pointer' }}>✕</button>
</div>
            </div>
            <div style={{ padding: '20px' }}>
              {editingContact ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  <p style={{ fontSize: '10px', letterSpacing: '3px', color: '#6B1A1A', margin: '0 0 4px' }}>EDIT CONTACT</p>
                  {[
                    { label: 'First Name', key: 'firstName' },
                    { label: 'Last Name', key: 'lastName' },
                    { label: 'Phone', key: 'phone' },
                    { label: 'Email', key: 'email' },
                    { label: 'Company', key: 'companyName' },
                  ].map(({ label, key }) => (
                    <div key={key}>
                      <p style={{ fontSize: '10px', color: '#888', letterSpacing: '2px', margin: '0 0 6px' }}>{label.toUpperCase()}</p>
                      <input
                        value={editForm[key]}
                        onChange={e => setEditForm({ ...editForm, [key]: e.target.value })}
                        style={{ width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', boxSizing: 'border-box' }}
                      />
                    </div>
                  ))}
                  {editStatus && <p style={{ fontSize: '12px', color: editStatus.includes('✓') ? '#4DB87A' : '#e07b39', margin: 0 }}>{editStatus}</p>}
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={async () => {
                        setEditStatus('Saving...');
                        try {
                          const res = await fetch(`${API}/api/ghl/contacts/${selectedContact.id}`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(editForm)
                          });
                          const data = await res.json();
                          if (data.success) {
                            setEditStatus('✓ Saved!');
                            const updatedName = `${editForm.firstName} ${editForm.lastName}`.trim();
                            setSelectedContact({ ...selectedContact, contactName: updatedName, phone: editForm.phone, email: editForm.email, companyName: editForm.companyName });
                            setContacts(prev => prev.map(c => c.id === selectedContact.id ? { ...c, contactName: updatedName, phone: editForm.phone, email: editForm.email, companyName: editForm.companyName } : c));
                            setTimeout(() => { setEditingContact(false); setEditStatus(''); }, 1000);
                          } else {
                            setEditStatus('Error saving changes.');
                          }
                        } catch (err) {
                          setEditStatus('Error: ' + err.message);
                        }
                      }}
                      style={{ flex: 1, backgroundColor: '#6B1A1A', color: '#f0ebe3', padding: '10px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif' }}
                    >
                      SAVE
                    </button>
                    <button onClick={() => { setEditingContact(false); setEditStatus(''); }} style={{ flex: 1, backgroundColor: 'transparent', border: '1px solid #d4c9bc', color: '#555', padding: '10px', fontSize: '11px', letterSpacing: '2px', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif' }}>
                      CANCEL
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  {[
                    ['Contact Name', selectedContact.contactName],
                    ['Company', selectedContact.companyName],
                ['Phone', selectedContact.phone],
                ['Email', selectedContact.email],
                ['Type', selectedContact.type],
                ['City', selectedContact.city],
                ['State', selectedContact.state],
                ['Tags', selectedContact.tags?.join(', ')],
                ['Date Added', selectedContact.dateAdded ? new Date(selectedContact.dateAdded).toLocaleDateString() : null],
                ['Website', selectedContact.website],
              ].filter(([, v]) => v).map(([k, v], i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '9px 0', borderBottom: '1px solid #d4c9bc' }}>
                  <p style={{ fontSize: '11px', color: '#888', margin: 0 }}>{k}</p>
                  <p style={{ fontSize: '12px', color: '#2a1a1a', margin: 0, textAlign: 'right', fontFamily: 'monospace' }}>{v}</p>
                </div>
              ))}

</>
              )}

              {/* NOTES SECTION */}
              <div style={{ marginTop: '20px' }}>
                <p style={{ fontSize: '10px', letterSpacing: '3px', color: '#6B1A1A', margin: '0 0 14px' }}>NOTES</p>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                  <input
                    value={newNote}
                    onChange={e => setNewNote(e.target.value)}
                    placeholder="Add a note..."
                    onKeyDown={async (e) => {
                      if (e.key === 'Enter' && newNote.trim()) {
                        await fetch(`${API}/api/notes/${selectedContact.id}`, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ note: newNote.trim(), created_by: profile?.full_name || 'Randy' })
                        });
                        setNewNote('');
                        fetchNotes(selectedContact.id);
                      }
                    }}
                    style={{ flex: 1, padding: '8px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none' }}
                  />
                  <button
                    onClick={async () => {
                      if (!newNote.trim()) return;
                      await fetch(`${API}/api/notes/${selectedContact.id}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ note: newNote.trim(), created_by: profile?.full_name || 'Randy' })
                      });
                      setNewNote('');
                      fetchNotes(selectedContact.id);
                    }}
                    style={{ backgroundColor: '#6B1A1A', color: '#f0ebe3', padding: '8px 16px', fontSize: '11px', letterSpacing: '1px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif' }}
                  >
                    ADD
                  </button>
                </div>
                {notes.length === 0 ? (
                  <p style={{ fontSize: '12px', color: '#bbb', fontStyle: 'italic', margin: 0 }}>No notes yet.</p>
                ) : notes.map((n, i) => (
                  <div key={i} style={{ padding: '10px 0', borderBottom: '1px solid #d4c9bc' }}>
                    <p style={{ fontSize: '13px', color: '#2a1a1a', margin: '0 0 4px', lineHeight: '1.5' }}>{n.note}</p>
                    <p style={{ fontSize: '10px', color: '#888', margin: 0, fontFamily: 'monospace' }}>{n.created_by} · {new Date(n.created_at).toLocaleString()}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CALL MODAL */}
      {selectedCall && (
        <div onClick={() => setSelectedCall(null)} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: '#f0ebe3', border: '1px solid #d4c9bc', borderRadius: '8px', width: '100%', maxWidth: '680px', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid rgba(201,168,130,0.2)', backgroundColor: '#4a1010', borderRadius: '8px 8px 0 0', flexShrink: 0 }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <p style={{ fontSize: '15px', fontWeight: '700', color: '#c9a882', margin: 0, fontFamily: 'Playfair Display, serif' }}>{selectedCall.customer?.number || 'Unknown Caller'}</p>
                  {isMissedCall(selectedCall) && <span style={{ fontSize: '9px', padding: '2px 8px', borderRadius: '20px', backgroundColor: 'rgba(224,123,57,0.2)', color: '#e07b39', fontWeight: '700', letterSpacing: '1px' }}>MISSED</span>}
                </div>
                <p style={{ fontSize: '10px', color: 'rgba(201,168,130,0.5)', margin: '3px 0 0', fontFamily: 'monospace' }}>
                  {selectedCall.startedAt ? new Date(selectedCall.startedAt).toLocaleString() : '—'} · {formatDuration(getCallDuration(selectedCall))}
                </p>
              </div>
              <button onClick={() => setSelectedCall(null)} style={{ background: 'none', border: 'none', color: '#c9a882', fontSize: '17px', cursor: 'pointer' }}>✕</button>
            </div>

            <div style={{ display: 'flex', borderBottom: '1px solid #d4c9bc', backgroundColor: '#4a1010', flexShrink: 0 }}>
              {['transcript', 'details', 'recording'].map(tab => (
                <button key={tab} onClick={() => setCallModalTab(tab)} style={modalTabStyle(tab)}>
                  {tab === 'transcript' ? 'TRANSCRIPT' : tab === 'details' ? 'CALL DETAILS' : 'RECORDING'}
                </button>
              ))}
            </div>

            <div style={{ overflowY: 'auto', flex: 1, padding: '24px' }}>

              {callModalTab === 'transcript' && (
                selectedCall.transcript ? (
                  selectedCall.transcript.split('\n').filter(line => line.trim()).map((line, i) => {
                    const isAI = line.startsWith('AI:');
                    const isUser = line.startsWith('User:');
                    const text = line.replace(/^(AI:|User:)\s*/, '');
                    return (
                      <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '14px', flexDirection: isAI ? 'row' : 'row-reverse' }}>
                        <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: isAI ? 'rgba(107,26,26,0.1)' : 'rgba(201,168,130,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', flexShrink: 0, color: isAI ? '#6B1A1A' : '#c9a882', fontWeight: '700' }}>
                          {isAI ? 'AI' : isUser ? 'U' : '?'}
                        </div>
                        <div style={{ maxWidth: '80%', backgroundColor: isAI ? 'white' : 'rgba(107,26,26,0.06)', border: '1px solid #d4c9bc', borderRadius: '8px', padding: '10px 14px' }}>
                          <p style={{ fontSize: '10px', color: isAI ? '#6B1A1A' : '#c9a882', margin: '0 0 4px', letterSpacing: '1px', fontWeight: '700' }}>{isAI ? 'ALEX (AI)' : 'CALLER'}</p>
                          <p style={{ fontSize: '13px', color: '#2a1a1a', margin: 0, lineHeight: '1.6' }}>{text}</p>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p style={{ fontSize: '13px', color: '#888', fontStyle: 'italic', textAlign: 'center', padding: '30px 0' }}>No transcript available for this call.</p>
                )
              )}

              {callModalTab === 'details' && (
                <div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1px', backgroundColor: '#d4c9bc', border: '1px solid #d4c9bc', marginBottom: '24px' }}>
                    {[
                      { label: 'DURATION', value: formatDuration(getCallDuration(selectedCall)) },
                      { label: 'STATUS', value: isMissedCall(selectedCall) ? 'MISSED' : selectedCall.status || '—' },
                      { label: 'COST', value: selectedCall.cost ? `$${selectedCall.cost.toFixed(4)}` : '—' },
                    ].map((stat, i) => (
                      <div key={i} style={{ backgroundColor: '#f0ebe3', padding: '18px', textAlign: 'center' }}>
                        <p style={{ fontSize: '9px', letterSpacing: '3px', color: '#6B1A1A', margin: '0 0 6px' }}>{stat.label}</p>
                        <p style={{ fontSize: '22px', fontWeight: '700', color: stat.label === 'STATUS' && isMissedCall(selectedCall) ? '#e07b39' : '#2a1a1a', fontFamily: 'Playfair Display, serif', margin: 0 }}>{stat.value}</p>
                      </div>
                    ))}
                  </div>
                  {[
                    ['Caller Number', selectedCall.customer?.number],
                    ['Call Type', selectedCall.type],
                    ['Started At', selectedCall.startedAt ? new Date(selectedCall.startedAt).toLocaleString() : null],
                    ['Ended At', selectedCall.endedAt ? new Date(selectedCall.endedAt).toLocaleString() : null],
                    ['End Reason', selectedCall.endedReason?.replace(/-/g, ' ')],
                    ['Assistant', selectedCall.artifact?.assistantActivations?.[0]?.assistantName || selectedCall.assistantId],
                    ['Phone Number', selectedCall.phoneNumberId],
                    ['Call ID', selectedCall.id],
                  ].filter(([, v]) => v).map(([k, v], i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid #d4c9bc' }}>
                      <p style={{ fontSize: '11px', color: '#888', margin: 0, flexShrink: 0, marginRight: '20px' }}>{k}</p>
                      <p style={{ fontSize: '12px', color: '#2a1a1a', margin: 0, textAlign: 'right', fontFamily: 'monospace', wordBreak: 'break-all' }}>{v}</p>
                    </div>
                  ))}
                </div>
              )}

              {callModalTab === 'recording' && (
                <div>
                  {selectedCall.recordingUrl || selectedCall.artifact?.recordingUrl ? (
                    <div>
                      <p style={{ fontSize: '10px', letterSpacing: '3px', color: '#6B1A1A', margin: '0 0 16px' }}>CALL RECORDING</p>
                      <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', padding: '20px', marginBottom: '16px' }}>
                        <p style={{ fontSize: '11px', color: '#888', margin: '0 0 12px', letterSpacing: '1px' }}>MONO (COMBINED)</p>
                        <audio controls style={{ width: '100%' }} src={selectedCall.recordingUrl || selectedCall.artifact?.recordingUrl} />
                      </div>
                      {selectedCall.artifact?.recording?.mono?.assistantUrl && (
                        <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', padding: '20px', marginBottom: '16px' }}>
                          <p style={{ fontSize: '11px', color: '#888', margin: '0 0 12px', letterSpacing: '1px' }}>AI VOICE ONLY</p>
                          <audio controls style={{ width: '100%' }} src={selectedCall.artifact.recording.mono.assistantUrl} />
                        </div>
                      )}
                      {selectedCall.artifact?.recording?.mono?.customerUrl && (
                        <div style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', padding: '20px' }}>
                          <p style={{ fontSize: '11px', color: '#888', margin: '0 0 12px', letterSpacing: '1px' }}>CALLER VOICE ONLY</p>
                          <audio controls style={{ width: '100%' }} src={selectedCall.artifact.recording.mono.customerUrl} />
                        </div>
                      )}
                    </div>
                  ) : (
                    <p style={{ fontSize: '13px', color: '#888', fontStyle: 'italic', textAlign: 'center', padding: '30px 0' }}>No recording available for this call.</p>
                  )}
                </div>
              )}

            </div>
          </div>
        </div>
      )}

{/* CREATE EVENT MODAL */}
      {showEventForm && (
        <div onClick={() => { setShowEventForm(false); setEventStatus(''); }} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', width: '460px', overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', backgroundColor: '#4a1010' }}>
              <p style={{ fontSize: '14px', fontWeight: '700', color: '#c9a882', margin: 0, fontFamily: 'Playfair Display, serif' }}>New Event</p>
              <button onClick={() => { setShowEventForm(false); setEventStatus(''); }} style={{ background: 'none', border: 'none', color: '#c9a882', fontSize: '17px', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {[
                { label: 'Title', key: 'title', placeholder: 'e.g. Roof inspection — Johnson', type: 'text' },
                { label: 'Contact Name', key: 'contact', placeholder: 'e.g. John Smith', type: 'text' },
                { label: 'Date', key: 'date', placeholder: '', type: 'date' },
                { label: 'Time', key: 'time', placeholder: '', type: 'time' },
                { label: 'Duration (minutes)', key: 'duration', placeholder: '60', type: 'number' },
              ].map(({ label, key, placeholder, type }) => (
                <div key={key}>
                  <p style={{ fontSize: '10px', color: '#888', letterSpacing: '2px', margin: '0 0 6px' }}>{label.toUpperCase()}</p>
                  <input
                    type={type}
                    value={eventForm[key]}
                    onChange={e => setEventForm({ ...eventForm, [key]: e.target.value })}
                    placeholder={placeholder}
                    style={{ width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
              ))}
              <div>
                <p style={{ fontSize: '10px', color: '#888', letterSpacing: '2px', margin: '0 0 6px' }}>TYPE</p>
                <select value={eventForm.type} onChange={e => setEventForm({ ...eventForm, type: e.target.value })} style={{ width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', boxSizing: 'border-box' }}>
                  <option value="appointment">Appointment</option>
                  <option value="follow-up">Follow-up</option>
                  <option value="job">Job</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <p style={{ fontSize: '10px', color: '#888', letterSpacing: '2px', margin: '0 0 6px' }}>NOTES</p>
                <textarea value={eventForm.notes} onChange={e => setEventForm({ ...eventForm, notes: e.target.value })} placeholder="Any additional notes..." rows={3} style={{ width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', boxSizing: 'border-box', resize: 'none' }} />
              </div>
              {eventStatus && <p style={{ fontSize: '12px', color: eventStatus.includes('✓') ? '#4DB87A' : '#e07b39', margin: 0 }}>{eventStatus}</p>}
              <button
                onClick={async () => {
                  if (!eventForm.title || !eventForm.date) { setEventStatus('Title and date are required.'); return; }
                  setEventStatus('Saving...');
                  try {
                    const sub = isClientView ? subdomain : 'hermes';
                    const res = await fetch(`${API}/api/calendar/${sub}`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ ...eventForm, created_by: profile?.full_name || 'Admin' })
                    });
                    const data = await res.json();
                    if (data.success) {
                      setEventStatus('✓ Event created!');
                      setEventForm({ title: '', date: '', time: '', duration: '60', type: 'appointment', notes: '', contact: '' });
                      await fetchEvents();
                      setTimeout(() => { setShowEventForm(false); setEventStatus(''); }, 1000);
                    } else {
                      setEventStatus('Error: ' + (data.error || 'Something went wrong'));
                    }
                  } catch (err) {
                    setEventStatus('Error: ' + err.message);
                  }
                }}
                style={{ backgroundColor: '#6B1A1A', color: '#f0ebe3', padding: '12px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif' }}
              >
                CREATE EVENT
              </button>
            </div>
          </div>
        </div>
      )}

{/* PLUGIN MANAGER MODAL */}
      {showPluginManager && selectedClient && (
        <div onClick={() => setShowPluginManager(false)} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', width: '100%', maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', backgroundColor: '#4a1010', position: 'sticky', top: 0 }}>
              <div>
                <p style={{ fontSize: '14px', fontWeight: '700', color: '#c9a882', margin: 0, fontFamily: 'Playfair Display, serif' }}>{selectedClient.business_name}</p>
                <p style={{ fontSize: '10px', color: 'rgba(201,168,130,0.5)', margin: '2px 0 0', fontFamily: 'monospace' }}>{selectedClient.subdomain}.hermespartnercapital.co</p>
              </div>
              <button onClick={() => setShowPluginManager(false)} style={{ background: 'none', border: 'none', color: '#c9a882', fontSize: '17px', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ padding: '24px' }}>
              <p style={{ fontSize: '10px', letterSpacing: '3px', color: '#6B1A1A', margin: '0 0 20px' }}>PLUGINS</p>
              {[
                { key: 'ai_call_log', label: 'AI Call Log', description: 'View all AI receptionist calls and transcripts', core: true },
                { key: 'contacts', label: 'Contacts & Pipeline', description: 'CRM contacts, pipeline view, notes', core: true },
                { key: 'activity', label: 'Activity Feed', description: 'Combined feed of calls and contacts', core: true },
                { key: 'contract_ai', label: 'Contract AI Agent', description: 'Upload contracts, extract info, generate material lists' },
                { key: 'satellite_estimates', label: 'Satellite Estimates', description: 'Cross-reference satellite imagery for job estimates' },
                { key: 'job_management', label: 'Job Management', description: 'Create and track jobs, assign to crew' },
                { key: 'invoicing', label: 'Invoicing', description: 'Generate and send invoices, track payments' },
                { key: 'sms_campaigns', label: 'SMS Campaigns', description: 'Send bulk SMS to contacts' },
                { key: 'reputation_management', label: 'Reputation Management', description: 'Automate review requests and responses' },
                { key: 'calendar', label: 'Calendar & Scheduling', description: 'Schedule jobs and appointments' },
                { key: 'team_members', label: 'Team Members', description: 'Add sub-users for sales reps and field crew' },
              ].map(plugin => {
                const isEnabled = selectedClient.plugins?.[plugin.key] ?? false;
                return (
                  <div key={plugin.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 0', borderBottom: '1px solid #d4c9bc' }}>
                    <div style={{ flex: 1, marginRight: '20px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#2a1a1a', margin: 0 }}>{plugin.label}</p>
                        {plugin.core && <span style={{ fontSize: '9px', padding: '2px 6px', backgroundColor: 'rgba(107,26,26,0.08)', color: '#6B1A1A', borderRadius: '20px', letterSpacing: '1px' }}>CORE</span>}
                      </div>
                      <p style={{ fontSize: '11px', color: '#888', margin: '3px 0 0' }}>{plugin.description}</p>
                    </div>
                    <div
                      onClick={async () => {
                        if (plugin.core) return;
                        const updatedPlugins = { ...selectedClient.plugins, [plugin.key]: !isEnabled };
                        setSelectedClient({ ...selectedClient, plugins: updatedPlugins });
                        setCrmClients(prev => prev.map(c => c.id === selectedClient.id ? { ...c, plugins: updatedPlugins } : c));
                        await fetch(`${API}/api/crm-clients/${selectedClient.id}/plugins`, {
                          method: 'PUT',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ plugins: updatedPlugins })
                        });
                      }}
                      style={{
                        width: '44px', height: '24px', borderRadius: '12px', cursor: plugin.core ? 'default' : 'pointer',
                        backgroundColor: isEnabled ? '#6B1A1A' : '#d4c9bc',
                        position: 'relative', flexShrink: 0, transition: 'background-color 0.2s'
                      }}
                    >
                      <div style={{
                        width: '18px', height: '18px', borderRadius: '50%', backgroundColor: 'white',
                        position: 'absolute', top: '3px', transition: 'left 0.2s',
                        left: isEnabled ? '23px' : '3px'
                      }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

{/* PROVISION CLIENT MODAL */}
      {showProvisionForm && (
        <div onClick={() => { setShowProvisionForm(false); setProvisionStatus(''); }} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', width: '100%', maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', backgroundColor: '#4a1010', position: 'sticky', top: 0 }}>
              <p style={{ fontSize: '14px', fontWeight: '700', color: '#c9a882', margin: 0, fontFamily: 'Playfair Display, serif' }}>Provision New Client</p>
              <button onClick={() => { setShowProvisionForm(false); setProvisionStatus(''); }} style={{ background: 'none', border: 'none', color: '#c9a882', fontSize: '17px', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {[
                { label: 'Business Name', key: 'business_name', placeholder: 'Acme Plumbing' },
                { label: 'Subdomain', key: 'subdomain', placeholder: 'acmeplumbing' },
                { label: 'Owner Name', key: 'owner_name', placeholder: 'John Smith' },
                { label: 'Owner Email', key: 'owner_email', placeholder: 'john@acmeplumbing.com' },
                { label: 'Owner Phone', key: 'owner_phone', placeholder: '+1 312 555 0000' },
                { label: 'Vapi Assistant ID', key: 'vapi_assistant_id', placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
                { label: 'GHL Location ID', key: 'ghl_location_id', placeholder: 'xxxxxxxxxxxxxxxxxxxxxxxx' },
                { label: 'GHL API Key', key: 'ghl_api_key', placeholder: 'pit-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' },
              ].map(({ label, key, placeholder }) => (
                <div key={key}>
                  <p style={{ fontSize: '10px', color: '#888', letterSpacing: '2px', margin: '0 0 6px' }}>{label.toUpperCase()}</p>
                  <input
                    value={provisionForm[key]}
                    onChange={e => {
                      const val = e.target.value;
                      setProvisionForm(prev => ({
                        ...prev,
                        [key]: val,
                        ...(key === 'business_name' ? { subdomain: val.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') } : {})
                      }));
                    }}
                    placeholder={placeholder}
                    style={{ width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
              ))}
              {provisionStatus && (
                <p style={{ fontSize: '12px', color: provisionStatus.includes('✓') ? '#4DB87A' : '#e07b39', margin: 0, lineHeight: '1.6' }}>{provisionStatus}</p>
              )}
              <button
                onClick={async () => {
                  if (!provisionForm.business_name || !provisionForm.owner_email) { setProvisionStatus('Business name and owner email are required.'); return; }
                  setProvisionStatus('Provisioning...');
                  try {
                    const res = await fetch(`${API}/api/provision-client`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ ...provisionForm, created_by: profile?.full_name || 'Admin' })
                    });
                    const data = await res.json();
                    if (data.success) {
                      setProvisionStatus(`✓ Client provisioned! Login: ${provisionForm.owner_email} / ${data.tempPassword}`);
                      await fetchCrmClients();
                      setProvisionForm({ business_name: '', subdomain: '', owner_name: '', owner_email: '', owner_phone: '', vapi_assistant_id: '', ghl_location_id: '', ghl_api_key: '' });
                    } else {
                      setProvisionStatus('Error: ' + (data.error || 'Something went wrong'));
                    }
                  } catch (err) {
                    setProvisionStatus('Error: ' + err.message);
                  }
                }}
                style={{ backgroundColor: '#6B1A1A', color: '#f0ebe3', padding: '14px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', marginTop: '4px' }}
              >
                PROVISION CLIENT
              </button>
            </div>
          </div>
        </div>
      )}

{/* CREATE CONTACT MODAL */}
      {showCreateContact && (
        <div onClick={() => { setShowCreateContact(false); setCreateStatus(''); }} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: 'white', border: '1px solid #d4c9bc', borderRadius: '8px', width: '440px', overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', backgroundColor: '#4a1010' }}>
              <p style={{ fontSize: '14px', fontWeight: '700', color: '#c9a882', margin: 0, fontFamily: 'Playfair Display, serif' }}>New Contact</p>
              <button onClick={() => { setShowCreateContact(false); setCreateStatus(''); }} style={{ background: 'none', border: 'none', color: '#c9a882', fontSize: '17px', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {[
                { label: 'First Name', key: 'firstName' },
                { label: 'Last Name', key: 'lastName' },
                { label: 'Phone', key: 'phone' },
                { label: 'Email', key: 'email' },
                { label: 'Company', key: 'companyName' },
              ].map(({ label, key }) => (
                <div key={key}>
                  <p style={{ fontSize: '10px', color: '#888', letterSpacing: '2px', margin: '0 0 6px' }}>{label.toUpperCase()}</p>
                  <input
                    value={newContact[key]}
                    onChange={e => setNewContact({ ...newContact, [key]: e.target.value })}
                    style={{ width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #d4c9bc', fontFamily: 'Cormorant Garamond, serif', color: '#2a1a1a', outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
              ))}
              {createStatus && <p style={{ fontSize: '12px', color: createStatus.includes('✓') ? '#4DB87A' : '#e07b39', margin: 0 }}>{createStatus}</p>}
              <button
                onClick={async () => {
                  if (!newContact.firstName && !newContact.phone) { setCreateStatus('Name or phone required.'); return; }
                  setCreateStatus('Creating...');
                  try {
                    const res = await fetch(`${API}/api/ghl/contacts/create`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ ...newContact })
                    });
                    const data = await res.json();
                    if (data.success) {
                      setCreateStatus('✓ Contact created!');
                      setNewContact({ firstName: '', lastName: '', phone: '', email: '', companyName: '' });
                      await fetchGHLData();
                      setTimeout(() => { setShowCreateContact(false); setCreateStatus(''); }, 1500);
                    } else {
                      setCreateStatus('Error: ' + (data.error || 'Something went wrong'));
                    }
                  } catch (err) {
                    setCreateStatus('Error: ' + err.message);
                  }
                }}
                style={{ backgroundColor: '#6B1A1A', color: '#f0ebe3', padding: '12px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: 'Cormorant Garamond, serif', marginTop: '4px' }}
              >
                CREATE CONTACT
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
